import { Button, Avatar } from "@mui/material";
import { styled } from "@mui/system";
const NotificationBTn = styled(Button)(({ theme }) => ({
  background: "transparent",
  boxShadow: "none",
  padding: "0px",
  minWidth: "auto",
  "&:hover": { background: "transparent", boxShadow: "none", padding: "0px" },
}));
const LogoutBTn = styled(Button)(({ theme }) => ({
  background: "#0C0C0C",
  borderRadius: "16px",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "20.298px",
  lineHeight: "28px",
  textAlign: "center",
  color: "#FFFFFF",
  textTransform: "capitalize",
  width: "80%",
  margin: "auto",
  "&:hover": { background: "#0C0C0C" },
  "&:disabled": {
    border: "none",
    color: "rgba(0, 0, 0, 0.26)",
    boxShadow: "none",
    backgroundColor: "rgba(0, 0, 0, 0.12)",
  },
}));

const PopoverWrape = styled("div")(({ theme }) => ({
  textAlign: "center",
  paddingTop: "20px",
  "& .userimfo": {
    marginTop: "20px",
    borderBottom: "1px solid #D9D9D9",
    paddingBottom: "15px",
    "& h6": {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "20px",
      lineHeight: "30px",
      textAlign: "center",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
    "& p": {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "18px",
      lineHeight: "20px",
      textAlign: "center",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
  },
  "& .logoutbtn": {
    paddingTop: "90px",
    paddingBottom: "20px",
  },
}));

const UserAvatar = styled(Avatar)(({ theme }) => ({
  width: "60px",
  height: "60px",
  backgroundColor: "#0B0B0B",
  margin: "auto",
  fontFamily: theme.typography.fontFamily,
}));

export { NotificationBTn, LogoutBTn, PopoverWrape, UserAvatar };
